import { GridIcon } from '@/features/experiences/components/Controls/controls/LayoutControl/GridIcon';

export const Box3RowIcon = () => {
  return <GridIcon squareCols={3} squareRows={4} />;
};
